import { defineMessages } from "react-intl";

export const troutesMessages = defineMessages({
  addToCollection: {
    id: "troutesMessages.addToCollection",
    defaultMessage: "Add to Collection",
  },
  archived: {
    id: "troutesMessages.archived",
    defaultMessage: "Archived",
  },
  created: {
    id: "troutesMessages.created",
    defaultMessage: "Created",
  },
  departed: {
    id: "troutesMessages.departed",
    defaultMessage: "Departed",
  },
  keyword: {
    id: "troutesMessages.keyword",
    defaultMessage: "Keyword",
  },
  loading: {
    id: "troutesMessages.loading",
    defaultMessage: "Loading {type} details",
  },
  noneFound: {
    id: "troutesMessages.noneFound",
    defaultMessage: "We couldn't find any {types} that matched your search",
  },
  noneMatched: {
    id: "segmentsMessages.noneMatched",
    defaultMessage: "No segments matched your search",
  },
  sortBy: {
    id: "troutesMessages.sortBy",
    defaultMessage: "Sort By",
  },
  startLocation: {
    id: "troutesMessages.startLocation",
    defaultMessage: "Start location (city, state)",
  },
  sortOptions: {
    id: "troutesMessages.sortOptions",
    defaultMessage: "Sort Options",
  },
  sortOrder: {
    id: "troutesMessages.sortOrder",
    defaultMessage: "Sort Order",
  },
  startsIn: {
    id: "troutesMessages.startsIn",
    defaultMessage: "Starts In",
  },
  updated: {
    id: "troutesMessages.updated",
    defaultMessage: "Updated",
  },
  viewFullDetails: {
    id: "troutesMessages.viewFullDetails",
    defaultMessage: "View Full Details",
  },
});
